<template>
    <div class="order">
        <search :search-obj-list="searchObjList"
                @reSearch="reSearch"
                :checkUrl="''"
                :showButton="false">
            <template #search="{item,pushTabTwo}">
                <div style="display: inline-block">
                    <div v-if="item.name===`${$t('goods.codeSearch')}`">
                        <goods-search-auto-complete :value.sync="item.value"
                                                    :placeholder="`${$t('goods.codeSearchPlaceholder')}`"
                                                    :goodsIdSearchObj="{param: 'id',name: `${$t('goods.codeSearch')}`}"
                                                    :goodsNoSearchObj="{param: 'code',name: `${$t('goods.codeSearch')}`}"
                                                    @setTags="pushTabTwo"/>
                    </div>
                </div>
            </template>
        </search>
        <div class="goods_list">
            <qx-table :qx-table="qxTable" @updateTable="updateTable" v-if="tableIsShow">
                <template slot="table" slot-scope="data">
                    <div v-for="(item, index) in data.table" :key="index" class="goods_item">
                        <div class="goods_msg">
                            <div class="content1">
                                <div class="content1_msg1">
                                    <div class="content1_type1" v-if="item.yarnType === '梭织布'">
                                        {{$t('goods.tatting')}}
                                    </div>
                                    <div class="content1_type2" v-if="item.yarnType === '针织布'">
                                        {{$t('goods.knit')}}
                                    </div>
                                    <div class="content1_code">
                                        {{ item.code }}
                                    </div>
                                </div>
                                <div class="content1_msg2" :style="item.yarnType ? '' : `padding-left: 0`" v-if="item.name">
                                    {{$t('goods.alias')}}：{{ item.name }}
                                </div>
                                <div class="content1_msg2" :style="item.yarnType ? '' : `padding-left: 0`" v-if="item.price && $isCurrentLang('zh')">
                                    单价：{{ item.price }}元/米
                                </div>
                            </div>
                            <!-- <div class="content5" v-if="$isCurrentLang('en')">
                                <div class="content1_msg1">
                                    <div class="content1_type1" v-if="item.yarnType === '梭织布'">
                                        {{$t('goods.tatting')}}
                                    </div>
                                    <div class="content1_type2" v-if="item.yarnType === '针织布'">
                                        {{$t('goods.knit')}}
                                    </div>
                                    <div class="content1_code">
                                        {{ item.code }}
                                    </div>
                                </div>
                                <div class="content1_msg2" :style="item.yarnType ? '' : `padding-left: 0`" v-if="item.name">
                                    {{$t('goods.alias')}}：{{ item.name }}
                                </div>
                                <div class="content2_bulk">
                                    <span>{{$t('goods.bulk')}}：</span>
                                    <span>
                                        {{ item.spotQuantity > 3000 ? '3000+' : item.spotQuantity }}{{$t('goods.meter')}}<span v-if="item.safetyStock">(<i class="tsiconfont icon-bodong" style="color: rgba(69, 183, 97, 1);cursor: default;"></i>{{ item.safetyStock }}{{$t('goods.meter')}})</span>
                                    </span>
                                </div>
                                <div class="content2_sample">
                                    <span>{{$t('goods.sample')}}：</span>
                                    <span>{{ item.sampleQuantity > 100 ? '100+' : item.sampleQuantity }}{{$t('goods.meter')}}</span>
                                </div>
                            </div> -->
                            <div class="content2">
                                <div class="content2_bulk">
                                    <span class="bulk_tag" v-if="item.safetyStock && item.safetyStock > 0 && $isCurrentLang('zh')">现货</span>
                                    <span>{{$t('goods.bulk')}}：</span>
                                    <span>
                                        {{ item.spotQuantity > 3000 ? '3000+' : item.spotQuantity }}{{$t('goods.meter')}}<span v-if="item.safetyStock">(滚动库存：{{ item.safetyStock }}{{$t('goods.meter')}})</span>
                                    </span>
                                    <el-tooltip class="item" effect="dark" content="去下单" placement="top" v-if="$isCurrentLang('zh')">
                                        <i class="tsiconfont icon-jiaoyixiadan"
                                           style="color: rgba(2, 167, 240, 1);font-size: 24px;"
                                           @click="toNotice(item, '大货')"
                                           v-if="item.spotQuantity">
                                        </i>
                                    </el-tooltip>
                                </div>
                                <div class="content2_sample">
                                    <span class="sample_tag" v-if="item.safetyStock && item.safetyStock > 0 && $isCurrentLang('zh')"></span>
                                    <span>{{$t('goods.sample')}}：</span>
                                    <span>{{ item.sampleQuantity > 100 ? '100+' : item.sampleQuantity }}{{$t('goods.meter')}}</span>
                                    <el-tooltip class="item" effect="dark" content="去下单" placement="top" v-if="$isCurrentLang('zh')">
                                        <i class="tsiconfont icon-jiaoyixiadan"
                                           style="color: rgba(2, 167, 240, 1);font-size: 24px;"
                                           @click="toNotice(item, '样品')"
                                           v-if="item.sampleQuantity">
                                        </i>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="content3" v-if="$isCurrentLang('zh')">
                                <!-- <div class="content3_self" @click="toOrderStock(item)">
                                    <el-tooltip class="item" effect="dark" content="查看更多" placement="top">
                                        <div>
                                            <span>本人待走：</span>
                                            <span>{{ item.selfPendingStock }}米</span>
                                        </div>
                                    </el-tooltip>
                                </div>
                                <div class="content3_all">
                                    <span>全部待走：</span>
                                    <span>{{ item.allPendingStock }}米</span>
                                </div> -->
                                <div class="content3_all">
                                    <span>本公司待发货：</span>
                                    <span>{{ item.companyPendingStock || 0 }}米</span>
                                </div>
                            </div>
                            <div class="content4" :style="$isCurrentLang('en') ? 'width: 40%' : ''">
                                <div class="content4_blend">
                                    <span>{{$t('goods.composition')}}：</span>
                                    <span>{{ item.blend }}</span>
                                </div>
                                <div class="content4_width">
                                    <span>{{$t('goods.width')}}：</span>
                                    <span>{{ item.width }}CM</span>
                                </div>
                                <div class="content4_weight">
                                    <span>{{$t('goods.weight')}}：</span>
                                    <span>{{ item.weight }}G/M²</span>
                                    <div class="report" @click="showReport(item)" v-if="$isCurrentLang('zh')">
                                        <i class="tsiconfont icon-xiangxiazhanhang" style="font-size: 24px;" v-if="!item.reportIsShow"></i>
                                        <i class="tsiconfont icon-xiangshangzhanhang" style="font-size: 24px;" v-if="item.reportIsShow"></i>
                                        <span style="padding-left: 4px;">测试报告</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="goods_report" v-if="item.reportIsShow">
                            <div class="goods_report_tips" v-if="!item.report.id">
                                <div v-if="item.reportLoading">
                                    <i class="el-icon-loading"></i>
                                    <span>加载中</span>
                                </div>
                                <div v-else>暂无测试报告</div>
                            </div>
                            <div class="goods_report_content" v-if="item.report.id">
                                <Report :currentGoods="item" :testMsg="item.report"></Report>
                            </div>
                            <div class="goods_report_download" v-if="item.report.id">
                                <div class="goods_report_download_btn" @click="exportReport(item)">
                                    <i class="icon-yunduanxiazai tsiconfont" style="color: rgba(2, 167, 240, 1);font-size: 24px"></i>
                                    <span style="color: rgba(2, 167, 240, 1);">下载</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </qx-table>
        </div>
    </div>
</template>

<script>
    import QxTable from '../../mixins/order/common/QxTable';
    import calculate from '../../plugins/calculate';
    import Report from '../../components/order/Report.vue';
    import { mapState } from 'vuex';
    import i18n from '../../i18n/index';

    export default {
        name: 'Goods',
        mixins: [QxTable],
        components: {Report},
        data() {
            return {
                searchObjList: [{
                    name: i18n.t('goods.codeSearch'),
                    param: 'code',
                    isShow: true,
                    searchType: 'slot',
                    type: 'autocomplete',
                }, {
                    name: i18n.t('goods.isStock'),
                    param: 'isStock',
                    isShow: true,
                    defaultValue: 1,
                    type: 'checkbox',
                    searchType: 'checkbox',
                    trueLabel: 1,
                    falseLabel: 0
                }, {
                    name: '备货白名单',
                    param: 'isSpot',
                    isShow: this.$isCurrentLang('zh'),
                    type: 'checkbox',
                    searchType: 'checkbox',
                    trueLabel: 1,
                    falseLabel: 0
                }],
                qxTable: {
                    url: '/base/info/product/stock',
                    table: [],
                    updateFlag: 0,
                    searchObj: {
                    }
                },
                tableIsShow: false
            };
        },
        computed: {
            ...mapState(['tab'])
        },
        methods: {
            defaultSearchObj() {
                return {
                    isPendingCompany: 1,
                    isPrice: 1
                };
            },
            reSearch(tags) {
                this.qxTable.searchObj = this.defaultSearchObj();
                tags.map(tag => {
                    this.qxTable.searchObj[tag.param] = tag.value;
                    return true;
                });
                if (this.qxTable.searchObj.code || this.qxTable.searchObj.id) {
                    this.tableIsShow = true;
                } else {
                    this.tableIsShow = false;
                }
                this.qxTable.updateFlag += 1;
            },
            updateTable(data) {
                this.qxTable.table = data.table.map(item => {
                    const obj = this.setGoods(item);
                    return {
                        ...obj,
                        report: {},
                        reportIsShow: false,
                        reportLoading: false
                    }
                });
            },
			setGoods(goods) {
				let spotQuantity = 0;
				let sampleQuantity = 0;
				let spotWarehouseStockVOList = [];
				let sampleWarehouseStockVOList = [];
				goods.warehouseStockVOList.forEach(item => {
					if (item.name === '样品') {
						sampleWarehouseStockVOList.push({
							...item
						});
						sampleQuantity = calculate.add(sampleQuantity, item.quantity);
					} else{
						spotWarehouseStockVOList.push({
							...item
						});
						spotQuantity = calculate.add(spotQuantity, item.quantity);
					}
				})
				return {
					...goods,
					spotQuantity,
					sampleQuantity,
					spotWarehouseStockVOList,
					sampleWarehouseStockVOList
				};
			},
            toNotice(item, type) {
                let query = {
                    goodsCode: item.code,
                    goodsId: item.id
                };
                let path = '';
                if (type === '大货') {
                    path = '/new-notice-order-dahuo';
                }
                if (type === '样品') {
                    path = '/new-notice-order-mayang';
                }
                if (this.tab.tabs.findIndex(e => e.path === path) === -1) {
                    this.$router.push({
                        path,
                        query
                    });
                } else {
                    this.$router.push({
                        path
                    });
                }
            },
            toOrderStock(item) {
                this.$router.push({
                    path: '/order-stock',
                    query: {
                        goodsId: item.id,
                        goodsNo: item.code
                    }
                });
            },
            async showReport(item) {
                item.reportIsShow = !item.reportIsShow;
                if (Object.keys(item.report).length === 0) {
                    item.reportLoading = true;
                    const { code, data: testData } = await this.qGet(`/inspect/test/report/Latest/${item.code}`);
                    if (code === 200) {
                        if (testData) {
                            item.report = testData;
                        }
                        item.reportLoading = false;
                    }
                }
            },
            async exportReport(item) {
                const Authorization = localStorage.getItem('token');
                const res = await this.qxAxios({
                    url: `/inspect/test/report/export/${item.report.id}`,
                    method: 'get',
                    headers: { Authorization },
                    responseType: 'blob'
                });
                if (res.status === 200) {
                    const blob = res.data;
                    if (blob) {
                        const a = document.createElement('a');
                        // a.download = `测试报告${item.type}:${item.id}.docx`;
                        a.download = `${item.report.artNo}:${item.report.rollNo}:${item.report.testDate}:测试报告.docx`;
                        a.href = URL.createObjectURL(blob);
                        a.click();
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .goods_list {
        .goods_item {
            .goods_msg {
                padding: 20px 30px;
                background-color: #fff;
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                .content5 {
                    width: 30%;
                    .content1_msg1 {
                        display: flex;
                        align-items: center;
                        .content1_type1 {
                            width: 24px;
                            border-radius: 4px;
                            font-size: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0 5px;
                            margin-right: 5px;
                            border: 1px solid rgba(99, 161, 3, 1);
                            color: rgba(99, 161, 3, 1);
                        }
                        .content1_type2 {
                            width: 24px;
                            border-radius: 4px;
                            font-size: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0 5px;
                            margin-right: 5px;
                            border: 1px solid rgba(236, 128, 141, 1);
                            color: rgba(236, 128, 141, 1);
                        }
                        .content1_code {
                            width: calc(100% - 24px);
                            font-size: 18px;
                            font-weight: 700;
                            word-break: break-all;
                            word-wrap: break-word;
                        }
                    }
                    .content1_msg2 {
                        font-size: 12px;
                        color: #555;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        line-height: normal;
                        padding-left: 39px;
                    }
                    .content2_bulk {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        font-size: 16px;
                        // padding: 5px 0;
                        .content2_stock {
                            width: calc(100% - 24px);
                            font-size: 16px;
                        }
                    }
                    .content2_sample {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        font-size: 16px;
                        // padding: 5px 0;
                    }
                }
                .content1 {
                    width: 20%;
                    .content1_msg1 {
                        display: flex;
                        align-items: center;
                        .content1_type1 {
                            width: 24px;
                            border-radius: 4px;
                            font-size: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0 5px;
                            margin-right: 5px;
                            border: 1px solid rgba(99, 161, 3, 1);
                            color: rgba(99, 161, 3, 1);
                        }
                        .content1_type2 {
                            width: 24px;
                            border-radius: 4px;
                            font-size: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0 5px;
                            margin-right: 5px;
                            border: 1px solid rgba(236, 128, 141, 1);
                            color: rgba(236, 128, 141, 1);
                        }
                        .content1_code {
                            width: calc(100% - 24px);
                            font-size: 18px;
                            font-weight: 700;
                            word-break: break-all;
                            word-wrap: break-word;
                        }
                    }
                    .content1_msg2 {
                        font-size: 12px;
                        color: #555;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        line-height: normal;
                        padding-left: 39px;
                    }
                }
                .content2 {
                    width: calc(30% - 10px);
                    padding-left: 10px;
                    font-size: 16px;
                    .content2_bulk {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        // padding: 5px 0;
                        .bulk_tag {
                            width: 24px;
                            border-radius: 4px;
                            font-size: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0 5px;
                            margin-right: 5px;
                            border: 1px solid rgba(245, 154, 45, 1);
                            color: rgba(245, 154, 45, 1);
                        }
                        .content2_stock {
                            width: calc(100% - 24px);
                            font-size: 16px;
                        }
                    }
                    .content2_sample {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        // padding: 5px 0;
                        .sample_tag {
                            width: 41px;
                        }
                    }
                }
                .content3 {
                    width: calc(25% - 10px);
                    padding-left: 10px;
                    font-size: 16px;
                    .content3_self {
                        color: rgba(2, 167, 240, 1);
                        cursor: pointer;
                        text-decoration: underline;
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        // padding: 5px 0;
                    }
                    .content3_all {
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        // padding: 5px 0;
                    }
                }
                .content4 {
                    width: calc(25% - 10px);
                    padding-left: 10px;
                    font-size: 16px;
                    height: 100%;
                    .content4_blend {
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        // padding: 5px 0;
                    }
                    .content4_width {
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        // padding: 5px 0;
                    }
                    .content4_weight {
                        display: flex;
                        align-items: center;
                        min-height: 32px;
                        flex-wrap: wrap;
                        // padding: 5px 0;
                        .report {
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            margin-left: 12px;
                            border-radius: 4px;
                            border: 1px solid rgba(2, 167, 240, 1);
                            color: rgba(2, 167, 240, 1);
                            padding: 4px 8px;
                        }
                    }
                }
            }
            .goods_report {
                width: 96%;
                background-color: #fff;
                margin-top: 2px;
                margin: 2px 2% 0 2%;
                display: flex;
                align-items: center;
                .goods_report_tips {
                    width: 100%;
                    height: 100px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    color: #b4b4b4;
                }
                .goods_report_content {
                    width: calc(100% - 80px);
                }
                .goods_report_download {
                    width: 80px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .goods_report_download_btn {
                        width: 50px;
                        height: 50px;
                        border-radius: 6px;
                        border: 1px solid rgba(2, 167, 240, 1);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }
                }
            }
        }
        ::v-deep .el-pagination {
            display: none !important;
        }
    }
</style>
